import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-2 w-full" }
const _hoisted_2 = ["name", "placeholder", "id", "required", "value"]

import { Ref, ref } from "vue";
import { useField } from "vee-validate";
import ErrorText from "@/components/Texts/ErrorText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputText',
  props: {
    name: {},
    placeholder: {},
    id: {},
    is_required: { type: Boolean },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(props.name, undefined, {
  initialValue: props.modelValue,
});
const emit = __emit;

const updateValue = ($event: Event) => {
  emit("update:modelValue", ($event.target as HTMLInputElement).value);
  handleChange($event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      class: "w-full placeholder-gray-400 focus:backdrop-blur-sm focus:border-purple-700 bg-opacity-10 bg-transparent border border-white rounded-lg px-4 py-2 text-[#e2e1e5] transition duration-200 shadow-md",
      name: props.name,
      placeholder: props.placeholder,
      id: props.id,
      required: props.is_required,
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (updateValue($event))),
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleBlur) && _unref(handleBlur)(...args)))
    }, null, 40, _hoisted_2),
    (_unref(errorMessage))
      ? (_openBlock(), _createBlock(ErrorText, {
          key: 0,
          class: "text-left",
          text: _unref(errorMessage)
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})